import React from 'react';
import { Container } from 'react-bootstrap';
import Rotate from 'react-reveal/Rotate';

export const Business = () => (
  <Container>

    <div style={styles.container}>

      <Rotate top right>

        <div style={styles.wrapper}>

          {/* =========================
              כותרת ראשית
          ========================= */}

          <div style={styles.headerCard}>

            <div style={styles.decorator}></div>

            <h1 style={styles.mainTitle}>

              תהליך הרישוי, מבנה מחלקת הנדסה וביקורת עסקים
            </h1>

            <p style={styles.introText}>
              הדרך לרישיון העסק עוברת דרך מספר תחנות מרכזיות:
              משרד הבריאות, מחלקת ההנדסה על שתי יחידותיה,
              ומחלקת ביקורת עסקים.
            </p>

            <p style={styles.introText}>
              הבנת תפקידה של כל יחידה ומחלקה תסייע לכם לעבור
              את התהליך בצורה חלקה, לחסוך זמן יקר ולמנוע
              טעויות תכנוניות חמורות.
            </p>

            <div style={styles.highlightBox}>
              <strong>
                להלן פירוט מבנה תהליך הרישוי והגורמים המעורבים בו:
              </strong>
            </div>

          </div>


          {/* =========================
              שלב 1
          ========================= */}

          <div style={styles.stageCard}>

            <div style={styles.stageHeader}>

              <div style={styles.stageNumber}>
                01
              </div>

              <div>
                <h2 style={styles.stageTitle}>
                  בדיקת תקינות וטיפול מול מחלקת הנדסה לעסקים
                </h2>

                <p style={styles.stageSubtitle}>
                  בדיקת הנכס הפיזי והתאמתו לחוק
                </p>
              </div>

            </div>

            <p style={styles.text}>
              מחלקת הנדסה לעסקים היא הגוף האמון על בדיקת
              הנכס הפיזי והתאמתו לחוק. כדי לייעל את העבודה,
              המחלקה מחולקת לשתי יחידות נפרדות, כאשר כל אחת
              מהן בוחנת זווית אחרת של העסק שלכם.
            </p>


            {/* יחידה א */}

            <div style={styles.innerCard}>

              <div style={styles.innerNumber}>
                א
              </div>

              <div>

                <h3 style={styles.innerTitle}>
                  היחידה לתכנון הנדסי
                </h3>

                <p style={styles.text}>
                  יחידה זו מתמקדת בתכנון הפנימי של העסק
                  ובפונקציונליות שלו. היא מטפלת בתוכניות
                  המפורטות לניהול העסק שהוגשו על ידי בעל
                  מקצוע מוסמך, כגון אדריכל או מהנדס,
                  בהתאם לחוק רישוי עסקים.
                </p>

                <div style={styles.questionBox}>
                  <strong>
                    מה היחידה בודקת?
                  </strong>

                  <ul style={styles.list}>
                    <li>חלוקת המדורים הפנימית</li>
                    <li>עמידה בשטחי המינימום הנדרשים לסוג העסק</li>
                    <li>פתרונות נגישות לאנשים עם מוגבלויות</li>
                    <li>התאמת התכנון לדרישות החוק</li>
                    <li>תוכנית להצבת פרגוד או סגירת חורף במידת הצורך</li>
                  </ul>
                </div>

              </div>

            </div>


            {/* יחידה ב */}

            <div style={styles.innerCard}>

              <div style={styles.innerNumber}>
                ב
              </div>

              <div>

                <h3 style={styles.innerTitle}>
                  היחידה לרישוי הנדסי
                </h3>

                <p style={styles.text}>
                  יחידה זו מתמקדת בחוקיות המבנה והקרקע
                  ומחברת בין חוק רישוי עסקים לבין חוק
                  התכנון והבנייה.
                </p>

                <div style={styles.questionBox}>

                  <strong>
                    מה היחידה בודקת?
                  </strong>

                  <ul style={styles.list}>
                    <li>האם למבנה קיים היתר בנייה חוקי</li>
                    <li>האם אופי העסק תואם את ייעוד הקרקע</li>
                    <li>התאמה לתוכנית בניין עיר (תב"ע)</li>
                  </ul>

                </div>

                <div style={styles.warningSmall}>

                  <strong>
                    טיפול בחריגות – שימוש חורג:
                  </strong>

                  <p style={styles.smallText}>
                    במידה והיחידה מוצאת כי השימוש המבוקש
                    לעסק אינו תואם להיתר הבנייה או לתב"ע
                    הקיימת, הבקשה עשויה לעבור למסלול
                    הסדרה מיוחד – הליך בקשה לשימוש חורג.
                  </p>

                </div>

              </div>

            </div>

          </div>


          {/* =========================
              שלב 2
          ========================= */}

          <div style={styles.stageCard}>

            <div style={styles.stageHeader}>

              <div style={styles.stageNumber}>
                02
              </div>

              <div>

                <h2 style={styles.stageTitle}>
                  חוות דעת משרד הבריאות לתכנון העסק
                </h2>

                <p style={styles.stageSubtitle}>
                  בדיקת תברואה, סניטציה והתאמת התכנון
                </p>

              </div>

            </div>

            <p style={styles.text}>
              עבור עסקים רבים, בדגש על תחומי המזון,
              הקוסמטיקה והבריאות, אישור משרד הבריאות
              הוא תנאי סף שבלעדיו לא ניתן להתקדם בתהליך.
            </p>


            <div style={styles.infoCard}>

              <div style={styles.infoIcon}>
                ✓
              </div>

              <div>

                <h3 style={styles.infoTitle}>
                  אישור תוכניות מוקדם
                </h3>

                <p style={styles.text}>
                  בשלב זה מוגשות התוכניות האדריכליות
                  המפורטות, בדרך כלל בקנה מידה של 1:50,
                  למשרד הבריאות לצורך קבלת חוות דעת מקדמית.
                </p>

              </div>

            </div>


            <div style={styles.infoCard}>

              <div style={styles.infoIcon}>
                ✓
              </div>

              <div>

                <h3 style={styles.infoTitle}>
                  תברואה וסניטציה
                </h3>

                <p style={styles.text}>
                  משרד הבריאות יוודא כי התכנון מונע זיהום
                  צולב וכולל הפרדה מתאימה בין חומרי גלם
                  למוצרים מוכנים, מערכות נידוף וסינון אוויר,
                  מיקומי כיורים ומדורים בהתאם לדרישות,
                  פתרונות להפרדת שומנים ופינוי אשפה.
                </p>

              </div>

            </div>

          </div>


          {/* =========================
              שלב 3
          ========================= */}

          <div style={styles.stageCard}>

            <div style={styles.stageHeader}>

              <div style={styles.stageNumber}>
                03
              </div>

              <div>

                <h2 style={styles.stageTitle}>
                  הגשת הבקשה הרשמית לרישיון העסק
                </h2>

                <p style={styles.stageSubtitle}>
                  הגשת תיק הבקשה למחלקת רישוי עסקים
                </p>

              </div>

            </div>

            <p style={styles.text}>
              לאחר שהתוכניות קיבלו את אישורן של יחידות
              התכנון והרישוי ההנדסי ושל משרד הבריאות,
              ניתן להגיש רשמית את תיק הבקשה למחלקת
              רישוי עסקים ברשות המקומית.
            </p>


            <div style={styles.checklistBox}>

              <h3 style={styles.checklistTitle}>
                מה כולל תיק הבקשה?
              </h3>

              <div style={styles.checkItem}>
                <span style={styles.checkIcon}>✓</span>
                <span>תוכניות חתומות</span>
              </div>

              <div style={styles.checkItem}>
                <span style={styles.checkIcon}>✓</span>
                <span>חוזים ומסמכים נדרשים</span>
              </div>

              <div style={styles.checkItem}>
                <span style={styles.checkIcon}>✓</span>
                <span>אישורי תשלום אגרות</span>
              </div>

              <div style={styles.checkItem}>
                <span style={styles.checkIcon}>✓</span>
                <span>חוות הדעת שהתקבלו מגורמי הרישוי</span>
              </div>

            </div>


            <div style={styles.successBox}>

              <div style={styles.successIcon}>
                ✓
              </div>

              <div>

                <h3 style={styles.successTitle}>
                  היתר זמני
                </h3>

                <p style={styles.text}>
                  עם קליטת התיק ובדיקת תקינותו, הרשות
                  רשאית להנפיק היתר זמני המאפשר את פתיחת
                  העסק ותחילת פעילותו, במקביל לניתוב התיק
                  לקבלת אישורים סופיים משאר גורמי הרישוי,
                  כגון כבאות ומשטרה.
                </p>

              </div>

            </div>

          </div>


          {/* =========================
              שלב 4
          ========================= */}

          <div style={styles.stageCard}>

            <div style={styles.stageHeader}>

              <div style={styles.stageNumber}>
                04
              </div>

              <div>

                <h2 style={styles.stageTitle}>
                  מחלקת ביקורת עסקים והכנה לסיור בשטח
                </h2>

                <p style={styles.stageSubtitle}>
                  בדיקה פיזית של העסק והתאמה לתוכניות
                </p>

              </div>

            </div>

            <p style={styles.text}>
              לאחר שהעסק הוקם או שופץ בהתאם לתוכניות,
              מגיע שלב האכיפה והבדיקה הפיזית בשטח,
              המנוהל על ידי מחלקת ביקורת עסקים.
            </p>


            <div style={styles.auditBox}>

              <div style={styles.auditIcon}>
                🔍
              </div>

              <div>

                <h3 style={styles.auditTitle}>
                  ביקורת התאמה ותברואה
                </h3>

                <p style={styles.text}>
                  מפקחי המחלקה יגיעו לעסק לסיור פיקוח
                  כדי לוודא קיומה של התאמה מלאה ומדויקת
                  בין התוכנית שאושרה לבין הבנייה בפועל
                  בשטח, לצד בדיקה של שמירה על תנאי
                  תברואה נאותים.
                </p>

              </div>

            </div>


            <div style={styles.tipBox}>

              <div style={styles.tipIcon}>
                💡
              </div>

              <div>

                <h3 style={styles.tipTitle}>
                  כלים לעזרת בעל העסק
                </h3>

                <p style={styles.tipText}>
                  כדי להגיע מוכנים לביקורת ולמנוע עיכובים
                  או קנסות, מומלץ להיעזר במשאבים הקיימים
                  באתר העירייה. ניתן למצוא שם את המפרט
                  האחיד לעסקים, טיפים מעשיים של מומחים
                  וטפסי צ'ק ליסט מפורטים שיאפשרו לבצע
                  "בחינת דמה" לעסק לפני הגעת המפקחים.
                </p>

              </div>

            </div>

          </div>


          {/* =========================
              סיכום
          ========================= */}

          <div style={styles.summaryBox}>

            <div style={styles.summaryIcon}>
              ✓
            </div>

            <div>

              <h2 style={styles.summaryTitle}>
                חשוב לזכור
              </h2>

              <p style={styles.summaryText}>
                תהליך רישוי העסק דורש תיאום בין מספר גורמים
                מקצועיים ורשויות. הכנה מוקדמת, בדיקת הנכס
                ותכנון נכון יכולים לחסוך זמן, כסף ועיכובים
                מיותרים בדרך לקבלת רישיון העסק.
              </p>

            </div>

          </div>

        </div>

      </Rotate>

    </div>

  </Container>
);

const styles = {

  /* =========================
     בסיס
  ========================= */

  container: {
    direction: 'rtl',
    width: '100%',
    minHeight: '100vh',
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    padding: '40px 15px',
    textAlign: 'center',
    background: 'linear-gradient(180deg, #f8fbfd 0%, #ffffff 100%)',
    boxSizing: 'border-box',
    overflowX: 'hidden',
  },

  wrapper: {
    width: '100%',
    maxWidth: '950px',
    margin: '0 auto',
    boxSizing: 'border-box',
  },


  /* =========================
     כותרת ראשית
  ========================= */

  headerCard: {
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: '#ffffff',
    borderRadius: '22px',
    padding: '40px 35px',
    marginBottom: '30px',
    boxShadow: '0 12px 35px rgba(0,0,0,0.07)',
    border: '1px solid #e6edf2',
    position: 'relative',
    overflow: 'hidden',
    textAlign: 'center',
  },

  decorator: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    height: '6px',
    background: 'linear-gradient(to left, #3498db, #2ecc71)',
  },

  mainTitle: {
    color: '#263238',
    fontSize: '1.8rem',
    fontWeight: '800',
    lineHeight: '1.5',
    margin: '10px 0 20px',
    textAlign: 'center',
    overflowWrap: 'break-word',
  },

  introText: {
    color: '#607d8b',
    fontSize: '1.05rem',
    lineHeight: '1.9',
    margin: '0 auto 15px',
    textAlign: 'center',
    maxWidth: '850px',
    overflowWrap: 'break-word',
  },

  highlightBox: {
    width: '100%',
    marginTop: '25px',
    padding: '20px',
    background: 'linear-gradient(135deg, #eef8ff, #f3fff8)',
    borderRadius: '13px',
    borderRight: '5px solid #3498db',
    color: '#2c3e50',
    fontSize: '1rem',
    lineHeight: '1.7',
    textAlign: 'center',
    boxSizing: 'border-box',
    overflowWrap: 'break-word',
  },


  /* =========================
     שלב
  ========================= */

  stageCard: {
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: '#ffffff',
    borderRadius: '20px',
    padding: '35px',
    marginBottom: '30px',
    boxShadow: '0 9px 28px rgba(0,0,0,0.06)',
    border: '1px solid #e6edf2',
    textAlign: 'center',
  },

  stageHeader: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '70px',
    marginBottom: '25px',
    paddingRight: '75px',
    paddingLeft: '20px',
    boxSizing: 'border-box',
    width: '100%',
  },

  stageHeaderContent: {
    width: '100%',
    minWidth: 0,
  },

  stageNumber: {
    position: 'absolute',
    right: '0',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '55px',
    height: '55px',
    minWidth: '55px',
    borderRadius: '16px',
    background: 'linear-gradient(135deg, #3498db, #2ecc71)',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '800',
    fontSize: '1rem',
    boxShadow: '0 5px 15px rgba(52,152,219,0.25)',
    zIndex: 2,
    boxSizing: 'border-box',
  },

  stageTitle: {
    color: '#263238',
    fontSize: '1.45rem',
    fontWeight: '800',
    margin: 0,
    lineHeight: '1.5',
    textAlign: 'center',
    width: '100%',
    overflowWrap: 'break-word',
  },

  stageSubtitle: {
    color: '#2980b9',
    fontSize: '0.95rem',
    fontWeight: '600',
    margin: '6px 0 0',
    textAlign: 'center',
    overflowWrap: 'break-word',
  },

  text: {
    color: '#607d8b',
    fontSize: '1rem',
    lineHeight: '1.95',
    margin: '0 auto',
    textAlign: 'center',
    maxWidth: '850px',
    overflowWrap: 'break-word',
  },


  /* =========================
     כרטיס פנימי
  ========================= */

  innerCard: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '18px',
    marginTop: '25px',
    padding: '25px',
    backgroundColor: '#f8fafc',
    borderRadius: '15px',
    border: '1px solid #e3eaf0',
    boxSizing: 'border-box',
    textAlign: 'center',
    width: '100%',
  },

  innerContent: {
    flex: 1,
    minWidth: 0,
  },

  innerNumber: {
    minWidth: '42px',
    width: '42px',
    height: '42px',
    borderRadius: '50%',
    backgroundColor: '#eaf4fb',
    color: '#2980b9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '800',
    fontSize: '1rem',
    flexShrink: 0,
    boxSizing: 'border-box',
  },

  innerTitle: {
    color: '#2980b9',
    fontSize: '1.2rem',
    fontWeight: '700',
    margin: '0 0 12px',
    textAlign: 'center',
    overflowWrap: 'break-word',
  },


  /* =========================
     שאלה + רשימה
  ========================= */

  questionBox: {
    width: '100%',
    marginTop: '18px',
    padding: '18px',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    borderRight: '4px solid #3498db',
    boxSizing: 'border-box',
    textAlign: 'center',
  },

  list: {
    margin: '12px auto 0',
    paddingRight: '22px',
    color: '#607d8b',
    lineHeight: '2',
    fontSize: '0.95rem',
    textAlign: 'right',
    display: 'inline-block',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },

  smallText: {
    color: '#607d8b',
    fontSize: '0.95rem',
    lineHeight: '1.8',
    margin: '8px auto 0',
    textAlign: 'center',
    overflowWrap: 'break-word',
  },


  /* =========================
     התראה קטנה
  ========================= */

  warningSmall: {
    width: '100%',
    marginTop: '18px',
    padding: '17px',
    backgroundColor: '#fff8e1',
    borderRadius: '10px',
    borderRight: '4px solid #f1c40f',
    color: '#6d5b23',
    boxSizing: 'border-box',
    textAlign: 'center',
  },


  /* =========================
     כרטיס מידע
  ========================= */

  infoCard: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '15px',
    marginTop: '20px',
    padding: '20px',
    backgroundColor: '#f8fafc',
    borderRadius: '13px',
    border: '1px solid #e5ebef',
    boxSizing: 'border-box',
    textAlign: 'center',
  },

  infoContent: {
    flex: 1,
    minWidth: 0,
  },

  infoIcon: {
    minWidth: '38px',
    width: '38px',
    height: '38px',
    borderRadius: '50%',
    backgroundColor: '#eaf7ef',
    color: '#27ae60',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    flexShrink: 0,
  },

  infoTitle: {
    color: '#2980b9',
    fontSize: '1.1rem',
    fontWeight: '700',
    margin: '0 0 8px',
    textAlign: 'center',
    overflowWrap: 'break-word',
  },


  /* =========================
     רשימת צ'ק
  ========================= */

  checklistBox: {
    width: '100%',
    marginTop: '25px',
    padding: '23px',
    backgroundColor: '#f8fafc',
    borderRadius: '14px',
    border: '1px solid #e3eaf0',
    boxSizing: 'border-box',
    textAlign: 'center',
  },

  checklistTitle: {
    color: '#263238',
    fontSize: '1.15rem',
    fontWeight: '700',
    marginBottom: '18px',
    textAlign: 'center',
  },

  checkItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    padding: '11px 0',
    color: '#607d8b',
    borderBottom: '1px solid #edf1f4',
    fontSize: '0.95rem',
    textAlign: 'center',
    width: '100%',
    boxSizing: 'border-box',
  },

  checkIcon: {
    minWidth: '28px',
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    backgroundColor: '#eaf7ef',
    color: '#27ae60',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    flexShrink: 0,
  },


  /* =========================
     הצלחה
  ========================= */

  successBox: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '15px',
    marginTop: '25px',
    padding: '22px',
    backgroundColor: '#f0fff4',
    borderRadius: '14px',
    border: '1px solid #c6f6d5',
    borderRight: '5px solid #2ecc71',
    boxSizing: 'border-box',
    textAlign: 'center',
  },

  successContent: {
    flex: 1,
    minWidth: 0,
  },

  successIcon: {
    minWidth: '40px',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: '#2ecc71',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '18px',
    flexShrink: 0,
  },

  successTitle: {
    color: '#27844a',
    fontSize: '1.15rem',
    fontWeight: '800',
    margin: '0 0 8px',
    textAlign: 'center',
  },


  /* =========================
     ביקורת
  ========================= */

  auditBox: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '18px',
    marginTop: '25px',
    padding: '25px',
    backgroundColor: '#f8fafc',
    borderRadius: '15px',
    border: '1px solid #e3eaf0',
    boxSizing: 'border-box',
    textAlign: 'center',
  },

  auditContent: {
    flex: 1,
    minWidth: 0,
  },

  auditIcon: {
    minWidth: '48px',
    width: '48px',
    height: '48px',
    borderRadius: '12px',
    backgroundColor: '#eaf4fb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '22px',
    flexShrink: 0,
  },

  auditTitle: {
    color: '#2980b9',
    fontSize: '1.2rem',
    fontWeight: '700',
    margin: '0 0 8px',
    textAlign: 'center',
  },


  /* =========================
     טיפ
  ========================= */

  tipBox: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '16px',
    marginTop: '25px',
    padding: '23px',
    borderRadius: '14px',
    background: 'linear-gradient(135deg, #fff8e1, #fffdf5)',
    border: '1px solid #f1d58a',
    borderRight: '5px solid #f1c40f',
    boxSizing: 'border-box',
    textAlign: 'center',
  },

  tipContent: {
    flex: 1,
    minWidth: 0,
  },

  tipIcon: {
    minWidth: '42px',
    width: '42px',
    height: '42px',
    borderRadius: '50%',
    backgroundColor: '#f1c40f',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '19px',
    flexShrink: 0,
  },

  tipTitle: {
    color: '#9a7610',
    fontSize: '1.15rem',
    fontWeight: '800',
    margin: '0 0 8px',
    textAlign: 'center',
  },

  tipText: {
    color: '#6d5b23',
    fontSize: '0.95rem',
    lineHeight: '1.8',
    margin: 0,
    textAlign: 'center',
    overflowWrap: 'break-word',
  },


  /* =========================
     סיכום
  ========================= */

  summaryBox: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '18px',
    padding: '28px',
    marginBottom: '40px',
    borderRadius: '18px',
    background: 'linear-gradient(135deg, #eefaf3, #f7fffb)',
    border: '1px solid #ccebd8',
    boxShadow: '0 7px 20px rgba(46,204,113,0.08)',
    boxSizing: 'border-box',
    textAlign: 'center',
  },

  summaryContent: {
    flex: 1,
    minWidth: 0,
  },

  summaryIcon: {
    minWidth: '48px',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: '#2ecc71',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '22px',
    flexShrink: 0,
  },

  summaryTitle: {
    color: '#27844a',
    fontSize: '1.3rem',
    fontWeight: '800',
    margin: '0 0 8px',
    textAlign: 'center',
  },

  summaryText: {
    color: '#4a6653',
    fontSize: '1rem',
    lineHeight: '1.8',
    margin: 0,
    textAlign: 'center',
    overflowWrap: 'break-word',
  },


  /* =====================================================
     TABLET / מסכים בינוניים
     768px ומטה
  ===================================================== */

  '@media (max-width: 768px)': {

    container: {
      padding: '25px 10px',
    },

    wrapper: {
      maxWidth: '100%',
    },

    headerCard: {
      padding: '30px 22px',
      marginBottom: '20px',
      borderRadius: '17px',
    },

    mainTitle: {
      fontSize: '1.45rem',
      lineHeight: '1.45',
    },

    introText: {
      fontSize: '0.92rem',
      lineHeight: '1.8',
    },

    highlightBox: {
      padding: '16px',
      fontSize: '0.9rem',
    },

    stageCard: {
      padding: '25px 20px',
      marginBottom: '20px',
      borderRadius: '16px',
    },

    stageHeader: {
      minHeight: '58px',
      paddingRight: '62px',
      paddingLeft: '10px',
      marginBottom: '20px',
    },

    stageNumber: {
      width: '46px',
      minWidth: '46px',
      height: '46px',
      borderRadius: '13px',
      fontSize: '0.85rem',
    },

    stageTitle: {
      fontSize: '1.15rem',
      lineHeight: '1.45',
    },

    stageSubtitle: {
      fontSize: '0.82rem',
    },

    text: {
      fontSize: '0.9rem',
      lineHeight: '1.85',
    },

    innerCard: {
      gap: '12px',
      padding: '18px',
      marginTop: '18px',
    },

    innerNumber: {
      width: '36px',
      minWidth: '36px',
      height: '36px',
      fontSize: '0.85rem',
    },

    innerTitle: {
      fontSize: '1rem',
    },

    questionBox: {
      padding: '14px',
    },

    list: {
      fontSize: '0.85rem',
      lineHeight: '1.85',
    },

    infoCard: {
      padding: '16px',
      gap: '12px',
    },

    infoIcon: {
      width: '34px',
      minWidth: '34px',
      height: '34px',
    },

    infoTitle: {
      fontSize: '1rem',
    },

    checklistBox: {
      padding: '18px',
    },

    checkItem: {
      fontSize: '0.85rem',
    },

    successBox: {
      padding: '18px',
    },

    auditBox: {
      padding: '18px',
    },

    tipBox: {
      padding: '18px',
    },

    summaryBox: {
      padding: '22px',
    },

  },


  /* =====================================================
     MOBILE
     עד 500px
  ===================================================== */

  '@media (max-width: 500px)': {

    container: {
      padding: '18px 7px',
      width: '100%',
      overflowX: 'hidden',
    },

    wrapper: {
      width: '100%',
      maxWidth: '100%',
    },

    headerCard: {
      padding: '22px 14px',
      marginBottom: '15px',
      borderRadius: '14px',
    },

    mainTitle: {
      fontSize: '1.2rem',
      lineHeight: '1.45',
      margin: '5px 0 12px',
    },

    introText: {
      fontSize: '0.82rem',
      lineHeight: '1.7',
      marginBottom: '10px',
    },

    highlightBox: {
      marginTop: '14px',
      padding: '13px 10px',
      borderRadius: '9px',
      borderRight: '3px solid #3498db',
      fontSize: '0.78rem',
      lineHeight: '1.65',
    },

    stageCard: {
      padding: '20px 13px',
      marginBottom: '15px',
      borderRadius: '14px',
    },

    stageHeader: {
      minHeight: '50px',
      marginBottom: '15px',
      paddingRight: '50px',
      paddingLeft: '4px',
    },

    stageNumber: {
      width: '38px',
      minWidth: '38px',
      height: '38px',
      borderRadius: '10px',
      fontSize: '0.72rem',
    },

    stageTitle: {
      fontSize: '1rem',
      lineHeight: '1.45',
    },

    stageSubtitle: {
      fontSize: '0.74rem',
      marginTop: '3px',
    },

    text: {
      fontSize: '0.78rem',
      lineHeight: '1.75',
    },

    innerCard: {
      display: 'block',
      marginTop: '14px',
      padding: '14px 11px',
      borderRadius: '10px',
    },

    innerNumber: {
      width: '30px',
      minWidth: '30px',
      height: '30px',
      fontSize: '0.75rem',
      margin: '0 auto 8px',
    },

    innerTitle: {
      fontSize: '0.9rem',
      marginBottom: '7px',
    },

    questionBox: {
      marginTop: '10px',
      padding: '11px 9px',
      borderRadius: '8px',
      borderRight: '3px solid #3498db',
    },

    list: {
      marginTop: '7px',
      paddingRight: '17px',
      paddingLeft: '2px',
      fontSize: '0.73rem',
      lineHeight: '1.75',
    },

    smallText: {
      fontSize: '0.74rem',
      lineHeight: '1.7',
    },

    warningSmall: {
      marginTop: '10px',
      padding: '11px',
      borderRadius: '8px',
      borderRight: '3px solid #f1c40f',
      fontSize: '0.74rem',
    },

    infoCard: {
      display: 'block',
      marginTop: '12px',
      padding: '13px 10px',
      borderRadius: '9px',
    },

    infoIcon: {
      width: '28px',
      minWidth: '28px',
      height: '28px',
      margin: '0 auto 7px',
      fontSize: '0.75rem',
    },

    infoTitle: {
      fontSize: '0.84rem',
      marginBottom: '5px',
    },

    checklistBox: {
      marginTop: '14px',
      padding: '14px 10px',
      borderRadius: '10px',
    },

    checklistTitle: {
      fontSize: '0.88rem',
      marginBottom: '10px',
    },

    checkItem: {
      gap: '7px',
      padding: '7px 0',
      fontSize: '0.73rem',
    },

    checkIcon: {
      width: '20px',
      minWidth: '20px',
      height: '20px',
      fontSize: '0.7rem',
    },

    successBox: {
      display: 'block',
      marginTop: '14px',
      padding: '14px 11px',
      borderRadius: '10px',
      borderRight: '3px solid #2ecc71',
    },

    successIcon: {
      width: '30px',
      minWidth: '30px',
      height: '30px',
      margin: '0 auto 8px',
      fontSize: '14px',
    },

    successTitle: {
      fontSize: '0.86rem',
      marginBottom: '5px',
    },

    auditBox: {
      display: 'block',
      marginTop: '14px',
      padding: '14px 11px',
      borderRadius: '10px',
    },

    auditIcon: {
      width: '34px',
      minWidth: '34px',
      height: '34px',
      margin: '0 auto 8px',
      borderRadius: '8px',
      fontSize: '16px',
    },

    auditTitle: {
      fontSize: '0.88rem',
      marginBottom: '5px',
    },

    tipBox: {
      display: 'block',
      marginTop: '14px',
      padding: '14px 11px',
      borderRadius: '10px',
      borderRight: '3px solid #f1c40f',
    },

    tipIcon: {
      width: '32px',
      minWidth: '32px',
      height: '32px',
      margin: '0 auto 8px',
      fontSize: '15px',
    },

    tipTitle: {
      fontSize: '0.86rem',
      marginBottom: '5px',
    },

    tipText: {
      fontSize: '0.73rem',
      lineHeight: '1.7',
    },

    summaryBox: {
      display: 'block',
      padding: '16px 11px',
      marginBottom: '20px',
      borderRadius: '12px',
    },

    summaryIcon: {
      width: '34px',
      minWidth: '34px',
      height: '34px',
      margin: '0 auto 8px',
      fontSize: '12px',
    },

    summaryTitle: {
      fontSize: '0.86rem',
      marginBottom: '5px',
    },

    summaryText: {
      fontSize: '0.74rem',
      lineHeight: '1.7',
    },

  },


  /* =====================================================
     MOBILE קטן מאוד
     עד 400px
  ===================================================== */

  '@media (max-width: 400px)': {

    container: {
      padding: '12px 5px',
      width: '100%',
      overflowX: 'hidden',
    },

    wrapper: {
      width: '100%',
      maxWidth: '100%',
    },

    headerCard: {
      padding: '18px 10px',
      marginBottom: '12px',
      borderRadius: '12px',
    },

    decorator: {
      height: '4px',
    },

    mainTitle: {
      fontSize: '1.05rem',
      lineHeight: '1.45',
      margin: '4px 0 10px',
    },

    introText: {
      fontSize: '0.78rem',
      lineHeight: '1.7',
      marginBottom: '9px',
    },

    highlightBox: {
      marginTop: '12px',
      padding: '10px 8px',
      borderRadius: '8px',
      borderRight: '3px solid #3498db',
      fontSize: '0.74rem',
      lineHeight: '1.65',
    },

    stageCard: {
      padding: '17px 9px',
      marginBottom: '12px',
      borderRadius: '12px',
    },

    stageHeader: {
      minHeight: '44px',
      marginBottom: '13px',
      paddingRight: '45px',
      paddingLeft: '2px',
    },

    stageNumber: {
      width: '34px',
      minWidth: '34px',
      height: '34px',
      borderRadius: '9px',
      fontSize: '0.65rem',
    },

    stageTitle: {
      fontSize: '0.9rem',
      lineHeight: '1.45',
    },

    stageSubtitle: {
      fontSize: '0.69rem',
      lineHeight: '1.5',
      marginTop: '3px',
    },

    text: {
      fontSize: '0.75rem',
      lineHeight: '1.75',
    },

    innerCard: {
      display: 'block',
      marginTop: '12px',
      padding: '12px 8px',
      borderRadius: '9px',
    },

    innerNumber: {
      width: '28px',
      minWidth: '28px',
      height: '28px',
      fontSize: '0.7rem',
      margin: '0 auto 7px',
    },

    innerTitle: {
      fontSize: '0.84rem',
      lineHeight: '1.45',
      marginBottom: '6px',
    },

    questionBox: {
      marginTop: '9px',
      padding: '9px 8px',
      borderRadius: '7px',
      borderRight: '3px solid #3498db',
      fontSize: '0.72rem',
    },

    list: {
      marginTop: '6px',
      paddingRight: '15px',
      paddingLeft: '0',
      fontSize: '0.7rem',
      lineHeight: '1.75',
    },

    smallText: {
      fontSize: '0.71rem',
      lineHeight: '1.7',
      marginTop: '5px',
    },

    warningSmall: {
      marginTop: '9px',
      padding: '9px 8px',
      borderRadius: '7px',
      borderRight: '3px solid #f1c40f',
      fontSize: '0.71rem',
    },

    infoCard: {
      display: 'block',
      marginTop: '10px',
      padding: '10px 8px',
      borderRadius: '8px',
    },

    infoIcon: {
      width: '26px',
      minWidth: '26px',
      height: '26px',
      margin: '0 auto 6px',
      fontSize: '0.7rem',
    },

    infoTitle: {
      fontSize: '0.79rem',
      marginBottom: '5px',
    },

    checklistBox: {
      marginTop: '12px',
      padding: '11px 8px',
      borderRadius: '9px',
    },

    checklistTitle: {
      fontSize: '0.82rem',
      marginBottom: '8px',
    },

    checkItem: {
      gap: '6px',
      padding: '6px 0',
      fontSize: '0.7rem',
      lineHeight: '1.5',
    },

    checkIcon: {
      width: '19px',
      minWidth: '19px',
      height: '19px',
      fontSize: '0.65rem',
    },

    successBox: {
      display: 'block',
      marginTop: '12px',
      padding: '11px 8px',
      borderRadius: '8px',
      borderRight: '3px solid #2ecc71',
    },

    successIcon: {
      width: '28px',
      minWidth: '28px',
      height: '28px',
      margin: '0 auto 7px',
      fontSize: '13px',
    },

    successTitle: {
      fontSize: '0.81rem',
      marginBottom: '5px',
    },

    auditBox: {
      display: 'block',
      marginTop: '12px',
      padding: '11px 8px',
      borderRadius: '8px',
    },

    auditIcon: {
      width: '31px',
      minWidth: '31px',
      height: '31px',
      margin: '0 auto 7px',
      borderRadius: '7px',
      fontSize: '14px',
    },

    auditTitle: {
      fontSize: '0.82rem',
      marginBottom: '5px',
    },

    tipBox: {
      display: 'block',
      marginTop: '12px',
      padding: '11px 8px',
      borderRadius: '8px',
      borderRight: '3px solid #f1c40f',
    },

    tipIcon: {
      width: '30px',
      minWidth: '30px',
      height: '30px',
      margin: '0 auto 7px',
      fontSize: '14px',
    },

    tipTitle: {
      fontSize: '0.81rem',
      marginBottom: '5px',
    },

    tipText: {
      fontSize: '0.7rem',
      lineHeight: '1.7',
    },

    summaryBox: {
      display: 'block',
      padding: '13px 8px',
      marginBottom: '15px',
      borderRadius: '10px',
    },

    summaryIcon: {
      width: '31px',
      minWidth: '31px',
      height: '31px',
      margin: '0 auto 7px',
      fontSize: '11px',
    },

    summaryTitle: {
      fontSize: '0.81rem',
      marginBottom: '5px',
    },

    summaryText: {
      fontSize: '0.71rem',
      lineHeight: '1.7',
    },

  },

};

